import { createContext, useContext } from 'react';

// This context is used to pass info and method calls between different children
// of SelectPanel. One example is, since the actual close button comes in as a
// child, it needs access to close the dropdown internally, which is made
// possible by this context.
var SelectPanelContext = /*#__PURE__*/createContext({});
var useSelectPanelContext = function useSelectPanelContext() {
  var context = useContext(SelectPanelContext);
  if (!context) {
    throw new Error('useSelectPanelContext must be used within a child of SelectPanel component');
  }
  return context;
};

export { SelectPanelContext, useSelectPanelContext };
